import { ILocaleStrings } from "loc/locale.interfaces";

// These relate to the enum DirectoryObjectPrincipalType in the api.
// Unknown = 0,
// MemberUser = 1,
// GuestUser = 2,
// SecurityGroup = 3,
// MailEnabledSecurityGroup = 4,
// M365Group = 5,
// DistributionList = 6,
// DirectoryRole = 7,
// AllMemberUsers = 8
export const getDirectoryObjectPrincipalTypeKey = (principalType: number): keyof ILocaleStrings => {
    switch (principalType) {
        case 0:
            return "unknown";
        case 1:
            return "ppaDirectoryObjectPrincipalTypeMemberUser";
        case 2:
            return "ppaDirectoryObjectPrincipalTypeGuestUser";
        case 3:
            return "ppaDirectoryObjectPrincipalTypeSecurityGroup";
        case 4:
            return "ppaDirectoryObjectPrincipalTypeMailEnabledSecurityGroup";
        case 5:
            return "ppaDirectoryObjectPrincipalTypeM365Group";
        case 6:
            return "ppaDirectoryObjectPrincipalTypeDistributionList";
        case 7:
            return "ppaDirectoryObjectPrincipalTypeDirectoryRole";
        case 8:
            return "ppaDirectoryObjectPrincipalTypeAllMemberUsers";
        default:
            return "unknown"
    }
}